<template>
  <v-list-item three-line>
    <slot name="icon"></slot>
    <v-skeleton-loader type="list-item-two-line" v-if="isLoading" />
    <v-list-item-content v-else-if="cost">
      <v-list-item-title class="text-truncate">
        <a v-if="hasOpenDetailListener()" @click.stop="emitOpenDetail">
          {{ cost.title }}
        </a>
        <span v-else> {{ cost.title }} </span>
      </v-list-item-title>
      <v-list-item-subtitle v-if="cost.description" class="text-truncate text-xs">
        {{ cost.description }}
      </v-list-item-subtitle>
    </v-list-item-content>
    <latest-entries-card-empty v-else />
  </v-list-item>
</template>

<script lang="ts">
import { CostGoToHelper } from "@/lib/utility/cost.go-to-helper";
import { ICostGroup } from "@/models/cost-group.entity";
import { mixins } from "vue-class-component";
import { Component, Prop, Vue } from "vue-property-decorator";
import { IRefDetail } from "./RefsList.vue";
import LatestEntriesCardEmpty from "../cards/LatestEntriesCardEmpty.vue";

@Component({
  components: { LatestEntriesCardEmpty },
  filters: {}
})
export default class RefsCostGroup extends mixins(Vue) implements IRefDetail<ICostGroup> {
  @Prop()
  item!: ICostGroup;

  @Prop()
  itemAsync!: Promise<ICostGroup>;

  @Prop()
  small!: boolean;

  @Prop()
  confirmable!: boolean;

  isLoading = false;

  cost: ICostGroup | null = null;

  hasClickListener() {
    return Boolean(this.$listeners && this.$listeners.click);
  }

  hasOpenDetailListener() {
    return Boolean(this.$listeners && this.$listeners.openDetail);
  }

  emitOpenDetail() {
    this.$emit("openDetail", this.item);
  }

  async beforeMount() {
    this.isLoading = true;

    if (this.item) {
      this.cost = this.item;
    } else if (this.itemAsync) {
      try {
        this.cost = await this.itemAsync;
      } catch (e) {
        this.$log.error(e);
      }
    }
    this.isLoading = false;
  }

  async goToDetail() {
    if (!this.cost) return;
    const partnerId = this.cost.partnerId;
    const costGroupId = this.cost.id;
    const newTab = true;

    new CostGoToHelper(this.$router).goToCostGroupDetail({ costGroupId, partnerId, newTab });
  }
}
</script>
<style lang="css" scoped>
.hoverCurserMouse :hover {
  cursor: pointer;
}
</style>
